// TODO(tsgo): Remove when microsoft/typescript-go#1034 is fixed (check after tsgo 7.1+)
import { createPoTemplate } from "./schema/po-templates/create-po-template";
import { deletePoTemplate } from "./schema/po-templates/delete-po-template";
import { getPoTemplate } from "./schema/po-templates/get-po-template";
import { getPoTemplates } from "./schema/po-templates/get-po-templates";
import { updatePoTemplate } from "./schema/po-templates/update-po-template";

export const groupI = {
  createPoTemplate,
  deletePoTemplate,
  getPoTemplate,
  getPoTemplates,
  updatePoTemplate,
};
